import { Badge, Flex, Input, Tag, TagLabel, TagCloseButton } from "@chakra-ui/react";
import { useState } from "react";

export function TagsInput({ tags, setTags }) {
  const [value, setValue] = useState('');

  function handleEnter(event) {
    if (event.key.toLowerCase() === "enter") {
      event.preventDefault();
      if (value.trim() !== '') {
        setTags(prev => [...prev, value]);
        setValue('');
      }
    }
  }

  function handleRemove(tagToRemove) {
    setTags(prev => prev.filter(tag => tag !== tagToRemove));
  }

  return (
    <Flex
      flexDirection={'column'}
      gap={4}
    >
      <Flex gap={2} flexWrap="wrap">
        {tags && tags.length > 0 && tags.map(tag => (
          <Tag key={tag}>
            <TagLabel>{tag}</TagLabel>
            <TagCloseButton onClick={() => handleRemove(tag)} />
          </Tag>
        ))}
      </Flex>
      <Input 
        value={value} 
        onChange={e => setValue(e.target.value)}
        placeholder="Pressione 'Enter' para adicionar..."
        onKeyDown={handleEnter}
      />
    </Flex>
  );
}